//region :: Imports ::
import MComponent from '../../Toolkit/Components/Component';
import {AddIconName, DenyIconName} from '../../Toolkit/Icons';
import MButton from '../../Toolkit/Components/Controls/Button';
import {MouseEventHandler, ReactElement} from 'react';
import {MBoolean} from '../../Toolkit/Components/Controls/Control';

//endregion

/** */
type Props = {
    systemName: string;
    existsInSystem: boolean;
    disabled: MBoolean;
    onClick?: MouseEventHandler<HTMLButtonElement>;
}

/** */
class MAddToSystemButton extends MComponent<Props> {

    /** */
    public render(): ReactElement {

        const label = this.props.existsInSystem ? `Added to ${this.props.systemName}` : `Add to ${this.props.systemName}`;
        const icon = this.props.existsInSystem ? DenyIconName : AddIconName;
        const disabled = this.props.existsInSystem || this.props.disabled;

        return (
            <MButton label={label}
                     icon={icon}
                     disabled={disabled}
                     onClick={this.props.onClick}/>
        );

    }

}

export default MAddToSystemButton;
